import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons";
import parse from "html-react-parser";
import { FormType } from "../../../types/forms";
import { t } from "i18next";
import cx from "classnames";

interface InlineHelpTextProps {
  text: string;
  formType: FormType;
}

function InlineHelpText({ text, formType }: InlineHelpTextProps) {
  const isCollabDoc = formType === "COLLAB-DOC";

  // Set colors based on form type
  const bgColor = isCollabDoc ? "bg-sky-50" : "bg-gray-50";
  const iconColor = isCollabDoc ? "text-sky-600" : "text-gray-600";
  const textColor = isCollabDoc ? "text-sky-700" : "text-gray-700";

  return (
    <div className={cx(bgColor, "rounded-lg py-2 px-4 my-2")}>
      <div className="flex gap-3">
        <FontAwesomeIcon
          icon={faCircleInfo}
          className={cx(iconColor, "mt-0.5")}
        />
        <p className={cx(textColor, "text-sm")}>{parse(t(text))}</p>
      </div>
    </div>
  );
}

export default InlineHelpText;
